import React from 'react'
import clsx from 'clsx'
import Head from 'next/head'
import {
  //  LayoutFooter,
  NotificationBanner,
  SearchBar,
  useLocale
} from '@plandi/common'
import Container from '@material-ui/core/Container'
import type { ContainerProps } from '@material-ui/core/Container'
import { useLayoutStyles, LayoutProps, NewFooter } from '../common'
import { CircularStatic } from '../Progress/progress'
import { useSelector } from 'react-redux'
import { RootState } from 'src/store'
import { BreadCrumbs } from 'src/features/breadcrumbs/breadcrumbs'
import { Dialog, useMediaQuery, useTheme } from '@material-ui/core'
import { NewHeader } from '../common/new-header/new-header'

export type breadcrumbInfoType = {
  title?: string
  href: string
}

export type MainLayoutProps = {
  withFooter?: boolean
  withoutSidebar?: boolean
  disableContainer?: boolean
  ContainerProps?: ContainerProps
  withSearchBar?: boolean
  redesignedLanding?: boolean
  description?: string
  title?: string
  image?: string
  keywords?: string[]
  containerStyle?: React.CSSProperties
  filterSidebar?: React.ReactNode
  searchType?: string
  footerClassName?: string
  breadcrumbInfo?: Array<breadcrumbInfoType> | undefined
}

export const MainLayout: React.FC<LayoutProps & MainLayoutProps> = (props) => {
  const classes = useLayoutStyles()
  const theme = useTheme()
  const locale = useLocale()
  const maxWidth = props.disableContainer ? false : 'xl'
  const isLoading = useSelector((state: RootState) => state?.loading?.loader)
  const isTablet = useMediaQuery(theme.breakpoints.down(960))
  return (
    <>
      <Head>
        <title>
          {props.title ??
            `${
              locale === 'ru'
                ? 'PlanDi «Проектный маркет»'
                : 'PlanDi «Project market»'
            }${props.title ? ` - ${props.title}` : ''}`}
        </title>
        {props.description && (
          <meta name="description" content={props.description} />
        )}
        {/* {props.keywords && (
          <meta name="keywords" content={props.keywords.join(' ')} />
        )} */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content={
            props.title ??
            `${
              locale === 'ru'
                ? 'PlanDi «Проектный маркет»'
                : 'PlanDi «Project market»'
            }${props.title ? ` - ${props.title}` : ''}`
          }
        />
        {props.description && (
          <meta property="og:description" content={props.description} />
        )}
        <meta
          property="og:image"
          content={
            props.image
              ? props.image
              : 'https://plandi-storage.storage.yandexcloud.net/storage/BG/A5/BGA5XjDEcYuq3002nbrhEJ0dtuVXAhk0KQ4R7FYg.jpg'
          }
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={
            props.description
              ? props.title
              : `${
                  locale === 'ru'
                    ? 'PlanDi «Проектный маркет»'
                    : 'PlanDi «Project market»'
                }${props.title ? ` - ${props.title}` : ''}`
          }
        />
        {props.description && (
          <meta name="twitter:description" content={props.description} />
        )}
        <meta
          name="twitter:image"
          content={
            props.image
              ? props.image
              : 'https://plandi-storage.storage.yandexcloud.net/storage/BG/A5/BGA5XjDEcYuq3002nbrhEJ0dtuVXAhk0KQ4R7FYg.jpg'
          }
        />
      </Head>
      <div
        className={clsx(
          classes.root,
          props.className,
          classes[props.withSearchBar ? 'grayColor' : 'root']
        )}
        style={{ position: 'relative' }}
      >
        {props.breadcrumbInfo && (
          <BreadCrumbs
            breadcrumbInfo={props.breadcrumbInfo}
            styles={{
              position: 'absolute',
              marginLeft: !isTablet ? '72px' : '20px',
              marginTop: '70px'
            }}
          />
        )}
        <NewHeader />
        {props.withSearchBar && (
          <SearchBar sticky withButton searchType={props.searchType}>
            {props.filterSidebar}
          </SearchBar>
        )}

        <div
          className={
            props?.redesignedLanding
              ? classes.redesignedLandingMain
              : classes.main
          }
          style={
            props.breadcrumbInfo
              ? { flexDirection: 'column', marginTop: '64px' }
              : { flexDirection: 'column' }
          }
        >
          <NotificationBanner service="shop" />
          <Dialog
            open={isLoading}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className={classes.backDrop}
          >
            <CircularStatic />
          </Dialog>
          <Container
            className={clsx(classes.mainContainer, {
              [classes.redesignedLandingMainContainer]: props.redesignedLanding,
              [classes.mainContainerWithoutSidebar]: props.withoutSidebar
            })}
            style={props.containerStyle}
            maxWidth={maxWidth}
            classes={{ maxWidthXl: classes.containerXl }}
            {...props.ContainerProps}
          >
            <>{props.children}</>
          </Container>
        </div>
        {props.withFooter && (
          <div className={clsx(classes.footer, props.footerClassName)}>
            {/*<LayoutFooter />*/}
            <NewFooter />
          </div>
        )}
      </div>
    </>
  )
}
